import React from 'react';
import { List, ListItem } from '@chakra-ui/react';
import { comparePlayerNames } from '../../../../commonUtils';
import Card from '../card/Card';
import CardHeader from '../card/CardHeader';
import PlayerListItem from './PlayerListItem';

export default function PlayerList(props) {
  const currentPlayers = Object.values(props.players || {}).filter(player => player.active && player.currentRoomID === props.roomID);
  const listType = 'Players';
  let players;
  if (currentPlayers.length) {
    players = currentPlayers.sort(comparePlayerNames).map(player => {
      const playerProps = {
        changeHost: () => props.reassignRoomHost(props.room?.roomID, player.playerID),
        currentPlayerIsHost: (props.currentPlayerID === props.room?.hostPlayerID),
        edit: props.modals.playerEditor.open,
        isCurrentPlayer: (player.playerID === props.currentPlayerID),
        isHost: (player.playerID === props.room?.hostPlayerID),
        isOwner: (player.playerID === props.room?.ownerPlayerID),
        kickPlayer: () => props.modals.kickPlayerDialog.open(player.playerID),
        player: player,
      };
      return <PlayerListItem key={player.playerID} {...playerProps} />;
    });
  } else {
    players = <ListItem key="empty" className="list-group-item empty-list">No {listType}</ListItem>;
  }
  return (
    <Card className="player-list" mb={props.mb ?? 5} boxShadow={props.boxShadow}>
      <CardHeader>{listType}</CardHeader>
      <List className="list-group">
        {players}
        {props.children}
      </List>
    </Card>
  );
}
